/*External dependencies */
import update from 'immutability-helper';

/* Local dependencies */
import { GetUserActions, GetUserActionTypes, User } from './action';

export interface GetUserStste {
  isGetUserModalOpen: boolean;
  isGetUserLoading: boolean;
  user: User;
  error: string;
}

export const initialGetUserState: GetUserStste = {
  isGetUserModalOpen: false,
  isGetUserLoading: false,
  user: {
    id: '',
    username: '',
    email: '',
    avatar: '',
    groupName: 0,
    joinDate: 0,
    status: null,
    phoneNumber: '',
    point: 0,
    __typename: null,
  },
  error: '',
};

export function getUserReducer(state = initialGetUserState, action: GetUserActions) {
  switch (action.type) {
    case GetUserActionTypes.OPEN_GET_USER_MODAL:
      return update(state, {
        isGetUserModalOpen: { $set: true },
      });
    case GetUserActionTypes.CLOSE_GET_USER_MODAL:
      return update(state, {
        isGetUserModalOpen: { $set: false },
        user: { $set: null },
      });
    case GetUserActionTypes.GET_USER_REQUEST:
      return update(state, {
        isGetUserLoading: { $set: true },
      });
    case GetUserActionTypes.GET_USER_SECCEEDED:
      return update(state, {
        isGetUserLoading: { $set: false },
        user: { $set: action.user },
      });
    case GetUserActionTypes.GET_USER_FAILED:
      return update(state, {
        isGetUserLoading: { $set: false },
        user: { $set: null },
      });
    default:
      return state;
  }
}
